import React, { useState } from 'react';
import { Box, Typography, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { selectQuestionObjectsForClueSelector } from '../../gameboard/gameBoardSlice';
import CategoryItem from './CategoryItem';
import { useDispatch } from 'react-redux';
import { beginQuestionAction, beginDailyDoubleAction } from '../../gameboard/gameBoardSlice';
import { selectGameId, selectGameStatusObject } from '../../gamestate/gameStateSlice';

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5),
  },
}));

const StyledList = styled(List)(({ theme }) => ({
  width: '100%',
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const CategoryList = () => {
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const questionObjects = useSelector(selectQuestionObjectsForClueSelector);
  const gameId = useSelector(selectGameId);
  const gameState = useSelector(selectGameStatusObject);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleQuestionSelect = (question) => {
    if (question.dailyDouble) {
      dispatch(beginDailyDoubleAction(gameId, gameState, question.id));
    } else {
      dispatch(beginQuestionAction(gameId, gameState, question.id));
    }
  };

  if (!questionObjects || questionObjects.length === 0) {
    return (
      <Root>
        <Typography align="center" color="textSecondary">
          Loading categories...
        </Typography>
      </Root>
    );
  }

  return (
    <Root>
      <StyledList>
        {questionObjects.map((category) => (
          <CategoryItem 
            key={category.label}
            category={category}
            isSelected={selectedCategory === category}
            onCategorySelect={handleCategorySelect}
            onQuestionSelect={handleQuestionSelect}
          />
        ))}
      </StyledList>
    </Root>
  );
};

export default CategoryList; 